import { toast } from "sonner";
import { humanizeApiErrorText } from "./formatApiError";

/** Sonner toast with API-safe copy (no raw JSON blobs). */
export function toastApiError(
  message: unknown,
  options?: Parameters<typeof toast.error>[1]
): ReturnType<typeof toast.error> {
  return toast.error(humanizeApiErrorText(message), options);
}
